import Skeleton from "@components/skeleton/Skeleton";
import React from "react";

import { IconButton } from "../../button";
import { CreatingTitle, ExpandIconBackground, ExpandIconParent, ExpandIconWrapper } from "../../formGroup";
import { MoreOptionsIcon } from "../../icon";
import SmartCollapsedBase, { ISmartCollapsedBaseProps } from "./SmartCollapsedBase";

interface IProps extends ISmartCollapsedBaseProps {
    isCollapsedGroupDisabled?: boolean;
    isSkeleton?: boolean;
}

class SmartCollapseToggle extends SmartCollapsedBase<IProps> {
    render() {
        if (this.props.isSkeleton) {
            return <SmartCollapseToggleSkeleton/>;
        }

        const { isCollapsedGroupDisabled, def } = this.props;
        const status = this.getStatus();

        return (
            <ExpandIconParent>
                <ExpandIconWrapper>
                    <ExpandIconBackground
                        $isCreating={status.isCreating}
                        $isDisabled={isCollapsedGroupDisabled}
                        onClick={this.handleToggle}
                        $expanded={status.isExpanded}>
                        <IconButton
                            title={this.props.storage.t(`Common:General.${status.isExpanded ? "Collapse" : "Expand"}`)}
                                    hotspotId={"formGroupExpand"}
                                    isLight
                                    isTransparent>
                            <MoreOptionsIcon isLight={!status.isCreating}/>
                        </IconButton>
                    </ExpandIconBackground>
                </ExpandIconWrapper>
                {status.isCreating &&
                    <CreatingTitle>{def.creatingTitle}</CreatingTitle>
                }
            </ExpandIconParent>
        );
    }
}

export default SmartCollapseToggle;

const SmartCollapseToggleSkeleton: React.FunctionComponent = () => {
    return <Skeleton width={"38px"} height={"38px"} borderRadius={"50%"}/>;
};